import { authFetch, getLocale } from "utils";

export const linkedinLogin = (code) =>
  authFetch(`${apiUrl}${version}/linkedin/auth/login`, {
    method: "POST",
    json: { code, locale: getLocale() },
  });

export const linkedinLink = (code) =>
  authFetch(`${apiUrl}${version}/linkedin/auth/link`, {
    method: "POST",
    json: { code, locale: getLocale() },
  });

export const linkedinRegister = (code) =>
  authFetch(`${apiUrl}${version}/linkedin/auth/register`, {
    method: "POST",
    json: { code, locale: getLocale() },
  });

export const outlook = (code) =>
  authFetch(`${apiUrl}${version}/outlook/auth`, {
    method: "POST",
    json: { code },
  });

export const gmail = (code) =>
  authFetch(`${apiUrl}${version}/gmail/auth`, {
    method: "POST",
    json: { code },
  });
